export const areaChartData = [{
    "id": 1,
    "value": 807528583,
    "date": "06/30/2021"
}, {
    "id": 2,
    "value": 463229285,
    "date": "03/21/2022"
}, {
    "id": 3,
    "value": 594995717,
    "date": "12/31/2021"
}, {
    "id": 4,
    "value": 836174929,
    "date": "08/08/2021"
}, {
    "id": 5,
    "value": 252183739,
    "date": "12/14/2021"
}, {
    "id": 6,
    "value": 351760941,
    "date": "07/08/2021"
}, {
    "id": 7,
    "value": 203451562,
    "date": "03/06/2022"
}, {
    "id": 8,
    "value": 624575234,
    "date": "06/04/2021"
}, {
    "id": 9,
    "value": 524124984,
    "date": "09/19/2021"
}, {
    "id": 10,
    "value": 315746864,
    "date": "10/18/2021"
}, {
    "id": 11,
    "value": 476474631,
    "date": "04/27/2021"
}, {
    "id": 12,
    "value": 497157204,
    "date": "09/13/2021"
}, {
    "id": 13,
    "value": 666200085,
    "date": "04/26/2021"
}, {
    "id": 14,
    "value": 555400656,
    "date": "01/15/2022"
}, {
    "id": 15,
    "value": 521103088,
    "date": "08/23/2021"
}, {
    "id": 16,
    "value": 564379788,
    "date": "10/06/2021"
}, {
    "id": 17,
    "value": 329306232,
    "date": "01/17/2022"
}, {
    "id": 18,
    "value": 712879020,
    "date": "10/22/2021"
}, {
    "id": 19,
    "value": 594169197,
    "date": "01/24/2022"
}, {
    "id": 20,
    "value": 211088281,
    "date": "12/19/2021"
}, {
    "id": 21,
    "value": 769276010,
    "date": "06/11/2021"
}, {
    "id": 22,
    "value": 228961922,
    "date": "11/01/2021"
}, {
    "id": 23,
    "value": 831655060,
    "date": "12/17/2021"
}, {
    "id": 24,
    "value": 660540909,
    "date": "09/09/2021"
}, {
    "id": 25,
    "value": 572226044,
    "date": "01/07/2022"
}, {
    "id": 26,
    "value": 100784731,
    "date": "09/11/2021"
}, {
    "id": 27,
    "value": 686645059,
    "date": "06/16/2021"
}, {
    "id": 28,
    "value": 164504375,
    "date": "09/03/2021"
}, {
    "id": 29,
    "value": 825654509,
    "date": "11/30/2021"
}, {
    "id": 30,
    "value": 807573183,
    "date": "06/29/2021"
}, {
    "id": 31,
    "value": 452836139,
    "date": "11/01/2021"
}, {
    "id": 32,
    "value": 854195824,
    "date": "11/17/2021"
}, {
    "id": 33,
    "value": 397188250,
    "date": "03/10/2022"
}, {
    "id": 34,
    "value": 456200093,
    "date": "02/21/2022"
}, {
    "id": 35,
    "value": 761670537,
    "date": "04/04/2021"
}, {
    "id": 36,
    "value": 314321470,
    "date": "07/11/2021"
}, {
    "id": 37,
    "value": 468484269,
    "date": "11/15/2021"
}, {
    "id": 38,
    "value": 655145748,
    "date": "09/30/2021"
}, {
    "id": 39,
    "value": 106465484,
    "date": "10/23/2021"
}, {
    "id": 40,
    "value": 575984572,
    "date": "07/03/2021"
}, {
    "id": 41,
    "value": 263633488,
    "date": "06/15/2021"
}, {
    "id": 42,
    "value": 337515900,
    "date": "10/21/2021"
}, {
    "id": 43,
    "value": 530879731,
    "date": "09/03/2021"
}, {
    "id": 44,
    "value": 160301083,
    "date": "08/06/2021"
}, {
    "id": 45,
    "value": 738647419,
    "date": "07/07/2021"
}, {
    "id": 46,
    "value": 524449644,
    "date": "06/05/2021"
}, {
    "id": 47,
    "value": 539126009,
    "date": "03/01/2022"
}, {
    "id": 48,
    "value": 751077800,
    "date": "08/03/2021"
}, {
    "id": 49,
    "value": 764968589,
    "date": "09/27/2021"
}, {
    "id": 50,
    "value": 160340848,
    "date": "04/20/2021"
}, {
    "id": 51,
    "value": 727070405,
    "date": "07/12/2021"
}, {
    "id": 52,
    "value": 479601274,
    "date": "06/13/2021"
}, {
    "id": 53,
    "value": 537043264,
    "date": "05/08/2021"
}, {
    "id": 54,
    "value": 339607962,
    "date": "11/18/2021"
}, {
    "id": 55,
    "value": 244566469,
    "date": "08/18/2021"
}, {
    "id": 56,
    "value": 735981654,
    "date": "03/14/2022"
}, {
    "id": 57,
    "value": 849200652,
    "date": "10/10/2021"
}, {
    "id": 58,
    "value": 167957500,
    "date": "02/04/2022"
}, {
    "id": 59,
    "value": 157718952,
    "date": "06/19/2021"
}, {
    "id": 60,
    "value": 551550311,
    "date": "05/18/2021"
}, {
    "id": 61,
    "value": 524582121,
    "date": "02/20/2022"
}, {
    "id": 62,
    "value": 105518403,
    "date": "03/10/2022"
}, {
    "id": 63,
    "value": 892370450,
    "date": "02/28/2022"
}, {
    "id": 64,
    "value": 164139380,
    "date": "05/24/2021"
}, {
    "id": 65,
    "value": 855318706,
    "date": "06/27/2021"
}, {
    "id": 66,
    "value": 476974486,
    "date": "12/20/2021"
}, {
    "id": 67,
    "value": 336416454,
    "date": "09/13/2021"
}, {
    "id": 68,
    "value": 526938936,
    "date": "02/02/2022"
}, {
    "id": 69,
    "value": 471187560,
    "date": "01/18/2022"
}, {
    "id": 70,
    "value": 656491474,
    "date": "11/28/2021"
}, {
    "id": 71,
    "value": 273717237,
    "date": "07/08/2021"
}, {
    "id": 72,
    "value": 480372467,
    "date": "03/30/2022"
}, {
    "id": 73,
    "value": 117398994,
    "date": "06/11/2021"
}, {
    "id": 74,
    "value": 557677247,
    "date": "11/15/2021"
}, {
    "id": 75,
    "value": 711635222,
    "date": "08/26/2021"
}, {
    "id": 76,
    "value": 720054959,
    "date": "11/30/2021"
}, {
    "id": 77,
    "value": 259232870,
    "date": "04/05/2021"
}, {
    "id": 78,
    "value": 709121016,
    "date": "01/14/2022"
}, {
    "id": 79,
    "value": 152011502,
    "date": "12/10/2021"
}, {
    "id": 80,
    "value": 132153049,
    "date": "09/20/2021"
}, {
    "id": 81,
    "value": 590312702,
    "date": "07/10/2021"
}, {
    "id": 82,
    "value": 415055826,
    "date": "10/31/2021"
}, {
    "id": 83,
    "value": 871333620,
    "date": "03/26/2022"
}, {
    "id": 84,
    "value": 661595715,
    "date": "09/25/2021"
}, {
    "id": 85,
    "value": 825236870,
    "date": "06/27/2021"
}, {
    "id": 86,
    "value": 628275597,
    "date": "07/07/2021"
}, {
    "id": 87,
    "value": 472411875,
    "date": "08/18/2021"
}, {
    "id": 88,
    "value": 128982283,
    "date": "04/12/2021"
}, {
    "id": 89,
    "value": 720541003,
    "date": "06/24/2021"
}, {
    "id": 90,
    "value": 108781751,
    "date": "05/19/2021"
}, {
    "id": 91,
    "value": 555026540,
    "date": "11/23/2021"
}, {
    "id": 92,
    "value": 814363852,
    "date": "07/24/2021"
}, {
    "id": 93,
    "value": 393954270,
    "date": "04/03/2022"
}, {
    "id": 94,
    "value": 182430820,
    "date": "04/18/2021"
}, {
    "id": 95,
    "value": 410818774,
    "date": "05/25/2021"
}, {
    "id": 96,
    "value": 458288987,
    "date": "08/21/2021"
}, {
    "id": 97,
    "value": 675412586,
    "date": "10/23/2021"
}, {
    "id": 98,
    "value": 220155360,
    "date": "12/04/2021"
}, {
    "id": 99,
    "value": 272891990,
    "date": "02/03/2022"
}, {
    "id": 100,
    "value": 773746389,
    "date": "09/29/2021"
}]


export const barChartData = [{
    "id": 1,
    "date": "12/15/2021",
    "value": 783042540
}, {
    "id": 2,
    "date": "09/22/2021",
    "value": 734924371
}, {
    "id": 3,
    "date": "01/21/2022",
    "value": 288887742
}, {
    "id": 4,
    "date": "07/18/2021",
    "value": 491196702
}, {
    "id": 5,
    "date": "03/12/2022",
    "value": 489907883
}, {
    "id": 6,
    "date": "01/28/2022",
    "value": 829716106
}, {
    "id": 7,
    "date": "10/02/2021",
    "value": 743126172
}, {
    "id": 8,
    "date": "02/17/2022",
    "value": 645547473
}, {
    "id": 9,
    "date": "12/30/2021",
    "value": 808098244
}, {
    "id": 10,
    "date": "08/06/2021",
    "value": 554869157
}, {
    "id": 11,
    "date": "05/27/2021",
    "value": 542593599
}, {
    "id": 12,
    "date": "03/30/2022",
    "value": 790508504
}, {
    "id": 13,
    "date": "03/13/2022",
    "value": 395473147
}, {
    "id": 14,
    "date": "10/17/2021",
    "value": 750010270
}, {
    "id": 15,
    "date": "09/07/2021",
    "value": 692025937
}, {
    "id": 16,
    "date": "06/15/2021",
    "value": 230056554
}, {
    "id": 17,
    "date": "02/11/2022",
    "value": 225130972
}, {
    "id": 18,
    "date": "05/16/2021",
    "value": 186969420
}, {
    "id": 19,
    "date": "05/02/2021",
    "value": 790541355
}, {
    "id": 20,
    "date": "06/21/2021",
    "value": 852274853
}, {
    "id": 21,
    "date": "08/26/2021",
    "value": 448983696
}, {
    "id": 22,
    "date": "11/20/2021",
    "value": 326136651
}, {
    "id": 23,
    "date": "10/14/2021",
    "value": 320656763
}, {
    "id": 24,
    "date": "01/31/2022",
    "value": 647057882
}, {
    "id": 25,
    "date": "11/05/2021",
    "value": 441221688
}, {
    "id": 26,
    "date": "05/31/2021",
    "value": 251679233
}, {
    "id": 27,
    "date": "01/22/2022",
    "value": 250219440
}, {
    "id": 28,
    "date": "05/22/2021",
    "value": 402222211
}, {
    "id": 29,
    "date": "03/28/2022",
    "value": 816127723
}, {
    "id": 30,
    "date": "02/22/2022",
    "value": 198863870
}, {
    "id": 31,
    "date": "02/24/2022",
    "value": 675206457
}, {
    "id": 32,
    "date": "10/04/2021",
    "value": 707884812
}, {
    "id": 33,
    "date": "02/23/2022",
    "value": 742542502
}, {
    "id": 34,
    "date": "06/12/2021",
    "value": 824886795
}, {
    "id": 35,
    "date": "06/14/2021",
    "value": 436258975
}, {
    "id": 36,
    "date": "12/17/2021",
    "value": 208654297
}, {
    "id": 37,
    "date": "03/11/2022",
    "value": 191523760
}, {
    "id": 38,
    "date": "10/28/2021",
    "value": 235536991
}, {
    "id": 39,
    "date": "08/03/2021",
    "value": 237348666
}, {
    "id": 40,
    "date": "12/14/2021",
    "value": 326816603
}, {
    "id": 41,
    "date": "11/11/2021",
    "value": 377376166
}, {
    "id": 42,
    "date": "08/08/2021",
    "value": 469749776
}, {
    "id": 43,
    "date": "09/15/2021",
    "value": 199391977
}, {
    "id": 44,
    "date": "03/27/2022",
    "value": 850654945
}, {
    "id": 45,
    "date": "04/22/2021",
    "value": 305376400
}, {
    "id": 46,
    "date": "04/27/2021",
    "value": 533337343
}, {
    "id": 47,
    "date": "03/09/2022",
    "value": 832490563
}, {
    "id": 48,
    "date": "09/19/2021",
    "value": 413500675
}, {
    "id": 49,
    "date": "09/13/2021",
    "value": 240139193
}, {
    "id": 50,
    "date": "01/10/2022",
    "value": 254238648
}, {
    "id": 51,
    "date": "03/04/2022",
    "value": 634789824
}, {
    "id": 52,
    "date": "08/13/2021",
    "value": 786679604
}, {
    "id": 53,
    "date": "04/30/2021",
    "value": 523181239
}, {
    "id": 54,
    "date": "02/24/2022",
    "value": 221991898
}, {
    "id": 55,
    "date": "07/17/2021",
    "value": 289525382
}, {
    "id": 56,
    "date": "07/17/2021",
    "value": 572471078
}, {
    "id": 57,
    "date": "08/07/2021",
    "value": 338913151
}, {
    "id": 58,
    "date": "07/10/2021",
    "value": 156905238
}, {
    "id": 59,
    "date": "04/01/2022",
    "value": 750733734
}, {
    "id": 60,
    "date": "11/05/2021",
    "value": 301175802
}, {
    "id": 61,
    "date": "10/24/2021",
    "value": 353704883
}, {
    "id": 62,
    "date": "01/14/2022",
    "value": 199907429
}, {
    "id": 63,
    "date": "07/08/2021",
    "value": 449048990
}, {
    "id": 64,
    "date": "11/10/2021",
    "value": 784608383
}, {
    "id": 65,
    "date": "05/01/2021",
    "value": 820810972
}, {
    "id": 66,
    "date": "02/15/2022",
    "value": 375132396
}, {
    "id": 67,
    "date": "09/12/2021",
    "value": 825334686
}, {
    "id": 68,
    "date": "10/21/2021",
    "value": 530087017
}, {
    "id": 69,
    "date": "06/22/2021",
    "value": 475272882
}, {
    "id": 70,
    "date": "04/04/2021",
    "value": 363483836
}, {
    "id": 71,
    "date": "09/01/2021",
    "value": 711418385
}, {
    "id": 72,
    "date": "08/27/2021",
    "value": 135181165
}, {
    "id": 73,
    "date": "03/11/2022",
    "value": 571588372
}, {
    "id": 74,
    "date": "02/05/2022",
    "value": 724555112
}, {
    "id": 75,
    "date": "05/15/2021",
    "value": 245394520
}, {
    "id": 76,
    "date": "10/20/2021",
    "value": 435532435
}, {
    "id": 77,
    "date": "10/26/2021",
    "value": 887127904
}, {
    "id": 78,
    "date": "01/22/2022",
    "value": 597182120
}, {
    "id": 79,
    "date": "08/01/2021",
    "value": 198210203
}, {
    "id": 80,
    "date": "07/26/2021",
    "value": 592528205
}, {
    "id": 81,
    "date": "11/17/2021",
    "value": 259057334
}, {
    "id": 82,
    "date": "10/19/2021",
    "value": 124217959
}, {
    "id": 83,
    "date": "01/28/2022",
    "value": 300704938
}, {
    "id": 84,
    "date": "08/26/2021",
    "value": 304673473
}, {
    "id": 85,
    "date": "12/31/2021",
    "value": 445991326
}, {
    "id": 86,
    "date": "04/26/2021",
    "value": 635005055
}, {
    "id": 87,
    "date": "01/07/2022",
    "value": 264956605
}, {
    "id": 88,
    "date": "03/10/2022",
    "value": 672289672
}, {
    "id": 89,
    "date": "04/22/2021",
    "value": 823745417
}, {
    "id": 90,
    "date": "01/05/2022",
    "value": 682917067
}, {
    "id": 91,
    "date": "01/01/2022",
    "value": 483491336
}, {
    "id": 92,
    "date": "04/10/2021",
    "value": 266491819
}, {
    "id": 93,
    "date": "08/28/2021",
    "value": 177075772
}, {
    "id": 94,
    "date": "08/07/2021",
    "value": 678288918
}, {
    "id": 95,
    "date": "03/05/2022",
    "value": 104240311
}, {
    "id": 96,
    "date": "11/19/2021",
    "value": 602331858
}, {
    "id": 97,
    "date": "11/30/2021",
    "value": 537681406
}, {
    "id": 98,
    "date": "02/01/2022",
    "value": 101084425
}, {
    "id": 99,
    "date": "06/23/2021",
    "value": 119073228
}, {
    "id": 100,
    "date": "12/20/2021",
    "value": 113615583
}]